export const tw = (classes: string) => classes;
